const Form103TC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "申請資料",
        collectionMeans: "收集電子聯絡方式",
        confirmation: "確認",
    },
    importantNotesContent: {
        statement: "本人已閱讀、明白及同意上述條款及細則。",
        termsConditions: "本人理解申請人需要擁有「智方便+」帳戶才能處理申請。",
    },

    note: {
        supervisorEmail: "(用作接收電子證書)",
        supervisorTel: "(用作通訊及接收手機短訊)",
        schoolCode: "(僅適用於已註冊學校)",
        receiveSMSChecked:
            "本人證明在本回條內所填報的資料均屬真確及完整。本人已細閱「個人資料收集聲明」，亦明白教育局就學校註冊及相關事宜，在有需要時會依據上述的電子聯絡方式，以手機短訊及/或電郵向本人發出電子通知(例如：申請獲批時發出電子版本的「學校註冊證明書或學校臨時註冊證明書」)。本人如不願意接收手機短訊，會在下列方格內填上「√」號，否則將被視為願意接收該些短訊。",
    },

    collectionMeans: {
        label: {
            schoolName: "學校名稱",
            schoolAddress: "學校地址",
            supervisorTitle: "校監稱謂",
            supervisorName: "校監姓名",
            supervisorEmail: "校監的電郵地址",
            supervisorTel: "校監的流動電話號碼",
            schoolCode: "學校編號",
            receiveSMSChecked: "本人不願意就學校註冊及相關事宜接收手機短訊。",
            receiveSMSNo: "本人願意就學校註冊及相關事宜接收手機短訊。",
        },
        errorMsg: {
            receiveSMSChecked: "請輸入一個有效的校監姓名",
            schoolCode: "學校編號必須為6位數",
        },
        option: {
            titleOption: {
                Mr: "先生",
                Miss: "小姐",
                Ms: "女士",
                Mrs: "太太",
            },
        },
    },
};

export default Form103TC;
